module.exports = __webpack_public_path__ + "/8c2768daf51e652c4bc959498c61cd44.png";